// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__1xrPE","Label":"Input_Label__1m79O","InputElement":"Input_InputElement__uuOpO","Invalid":"Input_Invalid__3Ah4R"};